import styled from '@emotion/styled';
import { ComponentProps } from 'react';
import { Color } from '../../../../../styles/Color';
import { Css, ITheme, Responsive } from '../../../../../ui';
import { IFlightStatus } from '../domain/models/IFlightStatus';

interface IProps extends ComponentProps<'div'> {
	status: string | IFlightStatus;
}

type IStatusVariant = 'default' | 'ghost' | 'error';

export function FlightStatusBadge({ status, ...props }: IProps) {
	const variant: IStatusVariant = getFlightStatusVariant(status);
	return (
		<StyledBadge data-variant={variant} {...props}>
			{IFlightStatus[status as keyof typeof IFlightStatus] ??
				IFlightStatus.Unknown}
		</StyledBadge>
	);
}

function getFlightStatusVariant(
	status: string | IFlightStatus,
): IStatusVariant {
	switch (status) {
		case IFlightStatus.Unknown:
			return 'ghost';
		case IFlightStatus.Canceled:
			return 'error';
		default:
			return 'default';
	}
}

const StyledBadge = styled.div<{}, ITheme>`
	display: inline-block;
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(16)};
	border-radius: 4px;
	white-space: nowrap;
	border: 1px solid transparent;

	font-size: ${Css.pxToRem(16)};
	font-weight: 500;

	&[data-variant='ghost'] {
		border: none;
		background-color: ${Color.Neutral2};
	}

	&[data-variant='default'] {
		border: 1px solid ${Color.BorderCard};
	}

	&[data-variant='error'] {
		background-color: ${Color.Error};
		color: ${Color.Neutral1};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(2)} ${Css.pxToRem(16)};
		max-height: ${Css.pxToRem(28)};
		align-content: center;
		text-align: center;
	}
`;
